import script from "./DomainsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainsPage.vue?vue&type=script&setup=true&lang=js"

import "./DomainsPage.vue?vue&type=style&index=0&id=131d99b9&scoped=true&lang=css"

import exportComponent from "/opt/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-131d99b9"]])

export default __exports__